import { memo } from 'react'

import { type VaultSymbol } from '@repo/common/queries/products'
import { useVaultInfo } from '@repo/common/queries/vaults'

import { InvestmentRow } from '../InvestmentRow'
import { VaultNav1yAPY } from '../updating_numbers/VaultNav1yAPY'
import { VaultPrice } from '../updating_numbers/VaultPrice'
import { VaultTVL } from '../updating_numbers/VaultTVL'

export const VaultRow = memo<{
  symbol?: VaultSymbol
  variant: ReactProps<typeof InvestmentRow>['variant']
  w?: ReactProps<typeof InvestmentRow>['w']
  // eslint-disable-next-line max-lines-per-function, complexity
}>(function VaultRow({ symbol, variant, w }) {
  const { data: vault } = useVaultInfo({ symbol })

  if (vault == null || symbol == null) return null

  return (
    <InvestmentRow
      symbol={vault.symbol}
      name={vault.name}
      price_per_token={<VaultPrice symbol={symbol} />}
      one_year_app_type=""
      one_year_apy={<VaultNav1yAPY symbol={symbol} />}
      tvl={<VaultTVL symbol={symbol} />}
      variant={variant}
      w={w}
    ></InvestmentRow>
  )
})
